export default "/_next/static/chunks/fonts/Montserrat ExtraLight-3e74621518c18613b8b2b49080c2782a.otf";